import React, { useState } from "react";
import { Navbar, Nav, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faChalkboardUser } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../Context/AuthContext";
import { useTranslation } from "react-i18next"; // Importer useTranslation

const Sidebar = () => {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { authData } = useAuth();

  return (
    <Navbar
      bg="light"
      variant="light"
      className="flex-column p-3 shadow-sm"
      style={{
        width: isOpen ? "250px" : "60px",
        transition: "width 0.3s",
        zIndex: "1",
      }}
    >
      <Button
        variant="outline-light"
        onClick={() => setIsOpen(!isOpen)}
        className="mb-3 ps-1"
        style={{ width: "100%" }}
      >
        <i
          className={`bi ${
            isOpen ? "bi-chevron-double-right" : "bi-chevron-double-left"
          } text-black fs-5 text-center`}
        ></i>
      </Button>

      <Nav className="flex-column">
        {authData.role === "instructor" && (
          <Nav.Link
            onClick={() => navigate("/add-program")}
            className="d-flex align-items-center fs-6 text-black"
          >
            <i className="bi bi-file-earmark-plus-fill"></i>
            {isOpen && <span className="ms-2">{t("create_course")}</span>}
          </Nav.Link>
        )}
        <Nav.Link
          onClick={() => navigate("/programs")}
          className="d-flex align-items-center fs-6 text-black"
        >
          <i className="bi bi-file-text-fill"></i>
          {isOpen && <span className="ms-2">{t("available_courses")}</span>}
        </Nav.Link>

        {authData.role === "instructor" && (
          <Nav.Link
            className="d-flex align-items-center fs-6 text-black"
            onClick={() => navigate("/request")}
          >
            <i className="bi bi-envelope-fill"></i>
            {isOpen && (
              <span className="ms-2">{t("view_access_requests")}</span>
            )}
          </Nav.Link>
        )}

        {authData.role === "admin" && (
          <Nav.Link
            className="d-flex align-items-center fs-6 text-black"
            onClick={() => navigate("/signup-requests")}
          >
            <i className="bi bi-envelope-fill"></i>
            {isOpen && (
              <span className="ms-2">{t("view_signup_requests")}</span>
            )}
          </Nav.Link>
        )}

        {authData.role === "user" && (
          <Nav.Link
            className="d-flex align-items-center fs-6 text-black"
            onClick={() => navigate("/myrequest")}
          >
            <i className="bi bi-envelope-fill"></i>
            {isOpen && (
              <span className="ms-2">{t("view_my_access_requests")}</span>
            )}
          </Nav.Link>
        )}

        <Nav.Link
          className="d-flex align-items-center fs-6 text-black"
          onClick={() => navigate("/myprograms")}
        >
          {authData.role === "user" ? (
            <FontAwesomeIcon icon={faChalkboardUser} />
          ) : (
            <FontAwesomeIcon icon={faBook} />
          )}
          {isOpen && (
            <span className="ms-2">
              {authData.role === "user"
                ? t("followed_courses")
                : t("my_courses")}
            </span>
          )}
        </Nav.Link>

        <Nav.Link
          className="d-flex align-items-center fs-6 text-black"
          onClick={() => navigate("/statistics")}
        >
          <i className="bi bi-bar-chart-fill"></i>
          {isOpen && <span className="ms-2">{t("statistics")}</span>}
        </Nav.Link>
      </Nav>
    </Navbar>
  );
};

export default Sidebar;
